import _ from 'lodash';
import cssUtil from 'gw-portals-util-js/CssUtil';

import template from 'text!./WizardStepCircles.html';
import styles from './WizardStepCircles-hashed.scss';

export default [function () {
    return {
        restrict: 'E',
        template: cssUtil.hashTemplate(template, styles),
        scope: {
            flowModel: '<'
        },
        controller: ['$scope', function ($scope) {
            $scope.steps = [];
            var currentStepIdx = 0;
            var updateSteps = function updateSteps() {
                $scope.steps.length = 0;
                Array.prototype.push.apply($scope.steps, $scope.flowModel.steps.filter(function (s) {
                    return s.label.hasLabel();
                }));

                currentStepIdx = _.findIndex($scope.steps, function (step) {
                    return step.name === $scope.flowModel.currentStep.name;
                });
                if (currentStepIdx === -1) {
                    // Consider any unlabeled steps to be at the end of the wizard
                    currentStepIdx = $scope.steps.length;
                }
            };
            updateSteps();

            $scope.isStepVisited = function (step) {
                return $scope.steps.indexOf(step) <= currentStepIdx;
            };
            $scope.isStepActive = function (step) {
                return $scope.steps.indexOf(step) === currentStepIdx;
            };
            $scope.isStepAccessible = function (step) {
                return !$scope.isStepActive(step) && $scope.flowModel.isStepAccessibleFromCurrent(step);
            };
            $scope.jumpToStep = function (step) {
                if ($scope.steps.indexOf(step) !== currentStepIdx && $scope.isStepAccessible(step)) {
                    $scope.flowModel.jumpToStep(step);
                }
            };

            $scope.flowModel.addStepChangeListener(updateSteps);
            $scope.$on('$destroy', function () {
                return $scope.flowModel.removeStepChangeListener(updateSteps);
            });

            $scope.hovered = -1;
            $scope.hover = function (i) {
                if ($scope.isStepAccessible($scope.steps[i])) {
                    $scope.hovered = i;
                }
            };
            $scope.dropHover = function () {
                $scope.hovered = -1;
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/directives/wizardStepCircles/WizardStepCircles.js
// module id = 1001
// module chunks = 0